import { Component, OnDestroy, OnInit, QueryList, ViewChildren, ChangeDetectorRef, NgZone, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { ToothStateDetailService } from '../../../services/toothStateDetail.service';
import { forkJoin, Subscription } from 'rxjs';
import { BOToothStateDetail } from '../../../models/odo/BOToothStateDetail.model';
import { FormBuilder, Validators } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material/expansion';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { DatePipe } from '@angular/common';
import { BOToothQuote } from '../../../models/odo/BOToothQuote.model';
import { BOToothQuoteDetail} from '../../../models/odo/BOToothQuoteDetail.model';
import { PersonService } from '../../../services/person.service';
import { BOPerson } from '../../../models/BOPerson.model';
import { Utilities } from '../../../common/utilities';
import { BOQuoteDataByTooth } from '../../../models/odo/BOQuoteDataByTooth.model';
import { BOToothQuoteDetailFace } from '../../../models/odo/BOToothQuoteDetailFace.model';

import { ToothQuoteService } from '../../../services/odo/toothQuote.service';
import { ToastrService } from 'ngx-toastr';
import { PdfService } from '../../../services/pdf.service';
import { DialogConfirmService } from '../../../services/dialog-confirm.service';
import { ToothFaceTypeService } from '../../../services/toothFaceType.service';
import { BOToothFaceType } from '../../../models/odo/BOToothFaceType.model';
import { CreateOrEditOdontologyHistoryComponent } from '../createOrEditOdontologyHistory.component';




pdfMake.vfs = pdfFonts.pdfMake.vfs;

type ToothQuoteNavState = {
  clinicHistoryId: number;
  personId: number;
  userName:string;
  isQuoteWithOdontograma?: boolean;
  action?: 'openToothQuote';
  action2?:'editToothQuote'
  toothQuote?:number,
  personDocumentId?:number
};

@Component({
  selector: 'app-quote',
  templateUrl: './quote.component.html',
  styleUrls: ['./quote.component.css'],
   providers: [DatePipe]
})

export class QuoteComponent implements OnInit, OnDestroy
{
    @ViewChildren(MatExpansionPanel) expansionPanels!: QueryList<MatExpansionPanel>;
 @ViewChild('createOrEditOdontologyHistoryModal') createOrEditOdontologyHistoryModal: CreateOrEditOdontologyHistoryComponent;
//#region declarations
clinicHistoryId:number=null;
personId:number=null;
userName:string="";
odontogramaId:number=null;

busyData$: Subscription;
busy: Subscription;

toothStateDetailList:BOToothStateDetail[][];
patient:BOPerson=new BOPerson();
//quoteDataList:BOQuoteDataByTooth[]=[];
today:Date=new Date();
totalPrice:number=0;
isSaved:boolean=false;
isQuoteWithOdontograma:boolean=false;
personDocumentId:number=null;
personDocumentIdString:string="";


//NUEVO
quote:BOToothQuote=new BOToothQuote();
quote2:BOQuoteDataByTooth=new BOQuoteDataByTooth();
quoteList:BOToothQuote[]=[];
quoteDataList2:BOQuoteDataByTooth[]=[];
quoteDataListFromTsd:BOQuoteDataByTooth[]=[]; //Tsd ToothSellDetail
quoteToPrint:BOToothQuote=new BOToothQuote();
showNewItem:boolean=false;
 //
expandedFaces: { [key: string]: boolean } = {};
toothFacesTypeList:BOToothFaceType[]=[];
toothFaces=[{id:1, name: 'Vestibular', }, {id:2, name:'Medial'}, {id:3, name:'Distal'}, {id:4, name:'Palatino'}, {id:5, name:'Oclusal'}];

toothDetailsForm= this._formBuilder.group({
  toothTypeId:   ['', Validators.required],
  treatment  :   ['', Validators.required],
  price      :   ['0', Validators.required],
  triage     :   ['', Validators.required],
  fixed      :   ['', Validators.required],
})

 itemForm = this._formBuilder.group({
  observations: ['', Validators.required],
 // treatment:    ['', Validators.required],
  price:        [0, Validators.required],
  fixed:        [false],
  });

//#endregion declarations

constructor(
          private _router                 :ActivatedRoute,
          private _routerOut              : Router,
          private _formBuilder            : FormBuilder,
          private _toothStateDetailService: ToothStateDetailService,
          private _person                 : PersonService,
          private _toothQuoteService      : ToothQuoteService,
          private _toothFaceTypeService   : ToothFaceTypeService,
          private _pdfService             : PdfService,
          private _toast                  : ToastrService,
          private datePipe                : DatePipe,
          private _dialogConfirm          : DialogConfirmService,
          private _ngZone                 : NgZone,
          private _cdr                    : ChangeDetectorRef


) { }


ngOnInit(): void
{
    // 1) Durante la navegación
    const navState = this._routerOut.getCurrentNavigation()?.extras.state as ToothQuoteNavState | undefined;
    console.log("En el ngOnInit navState es:", navState);

    // 2) Fallback si hubo refresh o entrada directa al historial
    const histState = (history.state || {}) as ToothQuoteNavState;

    const s = navState ?? histState;
    console.log("En el ngOnInit navState es:", s);

    // Disparar solo si viene el trigger correcto - viene de odontograma
    if (s?.action === 'openToothQuote')
    {
      this.openToothQuoteComponentState(s.clinicHistoryId, s.personId, s.userName, s.isQuoteWithOdontograma, s.personDocumentId);

      // (Opcional) Evitar que se vuelva a disparar si el usuario navega atrás/adelante:
      // history.replaceState({ ...history.state, action: undefined }, '');
    }
    else if(s?.action2=='editToothQuote') //viene de quote-history
    {
        this.getToothQuote(s.toothQuote);
    }
    else{
          this.patient= new BOPerson();
          this._router.queryParams.pipe(
          take(1)
        ).subscribe(params => {
          if (params['clinicHistory']) {
            this.clinicHistoryId = +params['clinicHistory']; // Convertir a número
          };

          if (params['personId']) {
            this.personId= +params['personId']; // Convertir a número
            this.patient.id=this.personId;
          };

          if (params['userName']) {
            this.userName = params['userName']; // string
          };

          if (params['isQuoteWithOdontograma']) {
            this.isQuoteWithOdontograma = params['isQuoteWithOdontograma']; // string
          };

            console.log('data en ngOnInit en el else final ', 'username is:',this.userName,
                                 'clinicHistoryId es:', this.clinicHistoryId,
                                 'this.patient.id es:', this.patient.id,
                                 'this.isQuoteWithOdontograma es:',this.isQuoteWithOdontograma);

        });

      this.openToothQuoteComponent(this.clinicHistoryId, this.personId, this.userName,false);
    }


}
//
/**
   * Genera una clave única para cada item dentro de cada quote
   */
  private getFaceKey(quoteIndex: number, itemIndex: number): string {
    return `${quoteIndex}-${itemIndex}`;
  }

  /**
   * Toggle para mostrar/ocultar faces de un item específico
   */
  toggleFaces(quoteIndex: number, itemIndex: number): void {
    const key = this.getFaceKey(quoteIndex, itemIndex);
    this.expandedFaces[key] = !this.expandedFaces[key];
  }

  /**
   * Verifica si los faces de un item están expandidos
   */
  isFacesExpanded(quoteIndex: number, itemIndex: number): boolean {
    const key = this.getFaceKey(quoteIndex, itemIndex);
    return this.expandedFaces[key] || false;
  }
// shouldShowFaces(quoteIndex: number, itemIndex: number, faces: any[]): boolean {
//   const isExpanded = this.isFacesExpanded(quoteIndex, itemIndex);
//   const hasFaces = faces && faces.length > 0;
//   return isExpanded && hasFaces;
// }
  /**
   * Elimina un item de la lista de un quote
   */
  deleteItemFaces(quoteIndex: number, itemIndex: number): void
  {
    if (this.quoteDataList2[quoteIndex]?.list) {
      this.quoteDataList2[quoteIndex].list.splice(itemIndex, 1);
      // Limpiar estado de expansión del item eliminado
      const key = this.getFaceKey(quoteIndex, itemIndex);
      delete this.expandedFaces[key];
    }
  }

  /**
   * Elimina un quote completo
   */
  deleteQuote(quoteIndex: number): void {

  let confirm:boolean=false;
      this._dialogConfirm.openConfirmDialog('¿Está seguro que desea borrar este elemento? ')
      .afterClosed().subscribe(res=>{
        confirm=res;

        if(confirm)
        {
          this.quoteDataList2.splice(quoteIndex, 1);
          // Limpiar todos los estados de expansión de ese quote
          Object.keys(this.expandedFaces).forEach(key => {
            if (key.startsWith(`${quoteIndex}-`)) {
              delete this.expandedFaces[key];
            }
          });

        }
        else
        {
          console.log("Se canceló el borrado de cotización:", quoteIndex)
        }
      });
    // this.quoteDataList2.splice(quoteIndex, 1);
    // // Limpiar todos los estados de expansión de ese quote
    // Object.keys(this.expandedFaces).forEach(key => {
    //   if (key.startsWith(`${quoteIndex}-`)) {
    //     delete this.expandedFaces[key];
    //   }
    // });
  }


//come from Odontograma. Creates quote with data from odontograma
openToothQuoteComponentState(clinicHistoryId:number, personId:number, personName:string, isQuoteWithOdontograma:boolean, personDocumentId?:number)
{

        console.log("Entra a otqc State. this.clinicHistoryId es", clinicHistoryId,
                  "personId es:", personId,
                  "userName es:", personName,
                  "isQuoteWithOdontograma es:", isQuoteWithOdontograma,
                  "personDocumentId es:", personDocumentId);


        this.clinicHistoryId =clinicHistoryId;
        this.personId=personId;
        this.userName=personName;
        this.isQuoteWithOdontograma=isQuoteWithOdontograma;
        this.personDocumentId=personDocumentId;


        this.busyData$ = forkJoin({
          resultToothStateDetails  : this._toothStateDetailService.getStateDetailsByChAgroupedByToothId(this.clinicHistoryId),
          resultPerson           : this._person.getPerson(this.personId),
          resultToothFaceType    : this._toothFaceTypeService.getAll(),
        }).subscribe({
          next: ({
            resultToothStateDetails,
            resultPerson,
            resultToothFaceType,
          }) => {
            this.toothStateDetailList= resultToothStateDetails;
            this.patient=resultPerson;
            this.toothFacesTypeList=resultToothFaceType;
            //ordenar por prioridad
            this.sortToothStateDetailsInPlace();
            //NUEVO
            this.toothStateDetailList.forEach(tsd=>{

              this.quote=new BOToothQuote();
              this.quote.date=new Date();
              this.quote.odontogramaId=this.odontogramaId;
              this.quote.clinicHistoryId=this.clinicHistoryId;
              this.quote.namePatient=Utilities.getNameFromPerson(this.patient);
              this.quote.patientId=this.patient.id; //tabla Person ->id
              //this.quote.patientDocumentId=parseInt(this.patient.personId);
              this.quote.patientDocumentIdString=this.patient.personId;


              tsd.forEach(td=>
              {
                  let boTqd=new BOToothQuoteDetail();
                  boTqd.toothQuoteId=-1;
                  boTqd.toothTypeId=td.toothTypeId;
                  boTqd.patientId=td.personId;
                 // boTqd.patientDocumentId=parseInt(this.patient.personId);
                  boTqd.patientDocumentIdString=this.patient.personId;
                  boTqd.date=td.date;
                  boTqd.odontogramaId=td.odontogramaId;
                  boTqd.clinicHistoryId=td.clinicHistoryOdontologyId;
                  boTqd.fixed=td.fixed;
                  boTqd.observations=td.observations;
                 // boTqd.treatment=td.treatment;
                  boTqd.price=td.price;
                  boTqd.toothTypeIdString=td.toothTypeId.toString();

                  let faces:BOToothQuoteDetailFace[]=[];
                  td.toothFaces.forEach(tsdf => {
                    let tqf= new BOToothQuoteDetailFace();
                    tqf.toothStateDetailId=tsdf.toothStateDetailId;
                    tqf.toothFaceId= tsdf.toothFaceId;
                    tqf.toothStateId= tsdf.toothStateId;
                    tqf.color= tsdf.color;
                    tqf.strokeColor=tsdf.strokeColor;
                    tqf.toothQuoteDetailId=-1;
                    faces.push(tqf);
                  });

             // boTqd.toothFaces=td.toothFaces;
                boTqd.toothFaces=faces;


              this.quote.toothQuoteDetails.push(boTqd);
              })

              this.quoteList.push(this.quote);

            });
          console.log(' this.toothStateDetilList es:',  this.toothStateDetailList);
         // console.log(' this.quote es:',  this.quote);
          console.log(' this.quoteList es:',  this.quoteList);
          let nameOfq=Utilities.getNameFromPerson(this.patient);
          this.quoteList.forEach(q=>{
            let boQuoteDbT= new BOQuoteDataByTooth();
            boQuoteDbT.patientName= nameOfq;
            boQuoteDbT.toothTypeIdString=q.toothQuoteDetails[0].toothTypeId.toString();
            boQuoteDbT.price=0;
            boQuoteDbT.incidents=0;
            q.toothQuoteDetails.forEach(t=>{
              boQuoteDbT.price+=t.price;
              boQuoteDbT.incidents+=1;
              boQuoteDbT.list.push(t);
            })
            //this.quoteDataList2.push(boQuoteDbT);
            this.quoteDataListFromTsd.push(boQuoteDbT);
          })
          this.quoteDataList2.sort((a, b) => Number(a.toothTypeIdString) - Number(b.toothTypeIdString));
          console.log(' this.quoteDataList2 es:',  this.quoteDataList2);
          },
          error: (err) => {
            console.error('Error al cargar los datos: ', err);
          },
          complete: () => {
            console.log('Carga de datos completa');
          }
        });
}

//come from createOrEditClinicHistory->fourth group. Creates quote within data of odontograma
openToothQuoteComponent(clinicHistoryId:number, personId:number,personName:string, isQuoteWithOdontograma:boolean):void
{
        console.log("Entra a otqc. this.clinicHistoryId es", this.clinicHistoryId,
                  "personId es:", personId,
                  "userName es:", personName,
                //  "odontoId es:", odontoId);
        )

        this.clinicHistoryId =clinicHistoryId;
        this.personId=personId;
        this.userName=personName;
        this.isQuoteWithOdontograma=isQuoteWithOdontograma;
       // this.personDocumentId=this.personDocumentId;

        this.busyData$ = forkJoin(
        {
          resultPerson           : this._person.getPerson(this.personId),

        }).subscribe(
          {
              next: ({
                resultPerson
              }) => {
                this.patient=resultPerson;
                console.log("En openToothQuoteComponent this.patient es:", this.patient);
              },
              error: (err) => {
                console.error('Error al cargar los datos: ', err);
              },
              complete: () => {
                console.log('Carga de datos completa');
              }
          });

}
//come from  quote-history
getToothQuote(quoteId: number)
{
      console.log('Entra a getToothQuote. quoteId es:', quoteId);
      this.quote=new BOToothQuote();



      this.busy = this._toothQuoteService.getToothQuote(quoteId)
      .subscribe(data=>{this.quote = data;
            //Ric

        if(this.quote){
          this.userName=this.quote.namePatient;
          this.clinicHistoryId= this.quote.clinicHistoryId;
          this.patient.id=this.quote.patientId;
          this.personId=this.quote.patientId;
         // this.patient.personId= this.quote.patientDocumentId.toString();
          this.patient.personId= this.quote.patientDocumentIdString; //No Document


          this.isQuoteWithOdontograma=false;

          this.totalPrice=this.quote.total;

          this._toast.success('Éxito', 'Obtuvo datos');

          console.log("En getToothQuote, this.quote es:", this.quote);

          // Opción 2: Usando Map para una solución más limpia
          const groupedMap = new Map<number, BOToothQuoteDetail[]>();

          this.quote.toothQuoteDetails.forEach(item => {
            const key = item.toothTypeId;
            if (!groupedMap.has(key)) {
              groupedMap.set(key, []);
            }
            groupedMap.get(key)!.push(item);
          });

          const groupedArray = Array.from(groupedMap.values());
          console.log("En getToothQuote, groupedArray:", groupedArray)
//crea quoteDataList2
          this.quoteDataList2=[];
          groupedArray.forEach(aq=>{
            let qd:BOQuoteDataByTooth= new BOQuoteDataByTooth();
            qd.patientName=this.quote.namePatient;
            qd.toothTypeIdString=aq[0].toothTypeId.toString();
            qd.incidents=aq.length;
             //calcula price
             let priceTemp=0;
             aq.forEach( d=>{
              priceTemp+=d.price;
               qd.list.push(d);
             })
             qd.price=priceTemp;
             this.quoteDataList2.push(qd);
          });
          this.quoteDataList2.sort((a, b) => Number(a.toothTypeIdString) - Number(b.toothTypeIdString));
        }
        else{
          this._toast.warning('No existen registros', 'No hay cotizaciones');
        }

      });

}

saveQuote()
{
  console.log("Entra a saveQuote en quote")
  let q:BOToothQuote= new BOToothQuote();
  let tqd:BOToothQuoteDetail[]=[];

  //Convierte a cero el id para evitar la edición y obligar a crear una nueva cotización
if(this.quote.id>0) q.id=this.quote.id;
//if(this.quote.id>0) q.id=0;

 q.name="Aleatorio";
 q.patientId=this.patient.id;
 //q.patientDocumentId=parseInt(this.patient.personId);
 q.patientDocumentIdString=this.patient.personId;
 q.date= new Date();
 q.odontogramaId= this.odontogramaId;
 q.namePatient=this.userName;
 q.clinicHistoryId=this.clinicHistoryId;

 let totalGeneral=0;
this.quoteDataList2.forEach(qdl=>{
   let total=0;

    qdl.list.forEach(d=>
      {
      tqd.push(d);
      total+=d.price;
    });
    qdl.price=total;
    totalGeneral+=total;

});

q.toothQuoteDetails=tqd;
q.total=totalGeneral;

console.log("En saveQuote, quote enviada es:", q);

  this._toothQuoteService.saveQuote(q).subscribe(data=>{
     console.log('En guardarValores this._toothStateDetailService devuelve:', data);
   })
}

calculateTotalQuote()
{
  this.totalPrice = 0;
  let tsdListLong: BOToothQuoteDetail[] = [];

  this.quoteDataList2.forEach(quo => {
    let priceQuo = 0;
    quo.list.forEach(bstd => {
      // Convertir a número, asegurando que sea un valor válido
      const priceValue = parseFloat(String(bstd.price).replace(',', '.')) || 0;
      priceQuo += priceValue;
      tsdListLong.push(bstd);
      this.totalPrice += priceValue;

      // Opcional: Actualizar el valor en el objeto a número
      bstd.price = priceValue;
    });
    quo.price = priceQuo;
  });

  // Resto del código...
this.quoteToPrint= new BOToothQuote();
this.quoteToPrint.name="Aleatorio";
this.quoteToPrint.patientId=this.patient.id;
this.quoteToPrint.patientDocumentIdString=this.patient.personId;
this.quoteToPrint.date= new Date();
this.quoteToPrint.odontogramaId= this.odontogramaId;
this.quoteToPrint.namePatient=this.userName;
this.quoteToPrint.clinicHistoryId=this.clinicHistoryId;

this.quoteDataList2.forEach(qdl=>{

    qdl.list.forEach(d=>{
      this.quoteToPrint.toothQuoteDetails.push(d);
    });

});

  //
  this.isSaved = true;
}
sortToothStateDetailsInPlace(): void {
  // Primero ordenar elementos dentro de cada sub-array
  this.toothStateDetailList.forEach(subArray => {
    subArray.sort((a: BOToothStateDetail, b: BOToothStateDetail) => a.id - b.id);
  });

  // Luego ordenar los sub-arrays por el menor id que contengan
  this.toothStateDetailList.sort((subArrayA, subArrayB) => {
    return subArrayA[0].toothTypeId - subArrayB[0].toothTypeId;
  });
}

openAllAccordions() {
    this.expansionPanels.forEach(panel => {
      panel.open();
    });
}

  // Método para cerrar todos los accordions
  closeAllAccordions() {
    this.expansionPanels.forEach(panel => {
      panel.close();
    });
  }


  showItemForm():void{
        this.showNewItem=true;
  }

  addItem():void
  {
    let qt:BOQuoteDataByTooth=new BOQuoteDataByTooth();

    qt.patientName= this.userName;
    qt.toothTypeIdString="Otro";
    qt.incidents=1;
    qt.price=0;

    let qtd:BOToothQuoteDetail=new BOToothQuoteDetail();
    qtd.toothQuoteId=-1;
    qtd.toothTypeId=0;
    qtd.patientId=this.patient.id;
    //qtd.patientDocumentId=parseInt(this.patient.personId);
    qtd.patientDocumentIdString=this.patient.personId;
    qtd.date=new Date();
    qtd.odontogramaId=this.odontogramaId;
    qtd.clinicHistoryId=this.clinicHistoryId;
    qtd.fixed=false;
    qtd.observations=this.itemForm.get('observations').value;
    //qtd.treatment=this.itemForm.get('treatment').value;
    qtd.price=parseInt(this.itemForm.get('price').value);
    qtd.toothTypeIdString="Otro";

    qt.list.push(qtd);

    this.quoteDataList2.push(qt);
    this.showNewItem=false;
    this.clearItemForm();
  }

  closeItemForm():void
  {
    this.clearItemForm();
    this.showNewItem=false;
  }

  navigateToOdontogramaFromQuote(clinicHistoryId:number, personId:number, userName:string){
    this._routerOut.navigate(['/dental-Admins/odontograma'], {

        queryParams: {
          clinicHistory: clinicHistoryId,
          personId: personId,
          userName:userName
        }
      });

  }

  addItemsFromOdontograma():void
  {
    this.quoteDataList2=[];
    this.quoteDataList2= this.quoteDataListFromTsd;
  }

deleteItem(posArray: number, posItem: number): void {
  this._dialogConfirm.openConfirmDialog('¿Está seguro que desea borrar este elemento? ')
    .afterClosed()
    .subscribe(res => {
      if (!res) {
        console.log("Se canceló el borrado del item:", posItem);
        return;
      }

      if (!this.quoteDataList2[posArray]) return;

      // Volvemos a entrar en la zona de Angular antes de mutar el estado
      this._ngZone.run(() => {

        const updatedList = this.quoteDataList2[posArray].list
          .filter((_, index) => index !== posItem);

        if (updatedList.length > 0) {
          // Nuevo array con nuevo objeto para el grupo modificado
          this.quoteDataList2 = this.quoteDataList2.map((group, index) =>
            index === posArray
              ? { ...group, list: [...updatedList], incidents: updatedList.length,  price: updatedList.reduce((sum, i) => sum + (+i.price || 0), 0) }
              : group
          );
        } else {
          // Grupo vacío → lo eliminamos
          this.quoteDataList2 = this.quoteDataList2
            .filter((_, index) => index !== posArray);
        }

        this._cdr.detectChanges();
      });
    });
}


trackByQuote(index: number, quote: any): any {
  // usa un id único si lo tienes, si no usa el índice
  return quote.id ?? index;
}

trackByItem(index: number, item: any): any {
  return item.id ?? index;
}
//#region print


  generateExternalPDF(quote:BOToothQuote)
  {
    console.log("Entra a generateExternalPDF");
    if(quote){
      console.log("quote tiene: ", quote);
    const documentDefinition = this.getDocumentDefinitionExternal(quote);
    this._pdfService.generateExternalPDF(documentDefinition);

    }

    else
      this._toast.warning("Fallo", "Debe calcular total de la cotización");
  }

  getDocumentDefinitionExternal(quote: BOToothQuote)
  {
    //separa los items con valor superior a 0
    const quoteWithPrice: BOToothQuoteDetail[]=quote.toothQuoteDetails.filter(detail=>detail.price > 0);

    console.log("Entra a getDocumentDefinition quote.toothQuoteDetails es:", quote.toothQuoteDetails);
    console.log("quoteToothToPrint es:", quoteWithPrice);
  let logoshort='data:image/png;base64,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';
    const formattedDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy');

    return {
      pageSize: 'A4',
      pageMargins: [20, 140, 20, 60],

      header: [
        {
          margin: [20, 30, 20, 10],

          columns:
          [
            {
              image: logoshort,
              width: 150,
              height: 57,
              alignment: 'left'
            },
            {
              fontSize: 9,
              text: [
                { text: 'Calle 5 Oeste Nª D-50-03\n' },
                { text: 'B/El Cortijo -Cali- Valle-Colombia\n' },
                { text: 'Telf: 316 4071420\n' },
                { text: 'NIT: 900260781\n', bold: true },

              ],
            alignment: 'left',
              margin: [30, 20, 0, 0]
            },
            {
              //fontSize: 16,
              text: [
                   { text: 'COTIZACIÓN\n', bold: true,  fontSize:16 },
                    { text: 'FECHA:', bold: true,fontSize: 10 },
                    { text: formattedDate +'\n', bold: true, fontSize: 10 },

              { text: 'PACIENTE:'+this.userName+'\n', bold: true, fontSize: 10 },
              ],
              alignment: 'left',
              margin: [0, 12, 0, 0]
            }
          ]
        },
        {

          columns:
          [
            {
              fontSize: 9,
              text: [

                { text: 'www.servivitalcentromedico.com.co' }
              ],
                margin: [20, 10, 20, 10],


            },
            {
              fontSize: 9,
              text: [
                { text: ' ' },
              ],
                margin: [20, 10, 20, 10],

            },
            {
              fontSize: 9,
              text: [

                { text: 'centromedicoservivital@gmail.com\n' },
              ],
                margin: [20, 10, 20, 10],
            },

          ]
        }


      ],


      footer: [
        {
          canvas: [
            { type: 'line', x1: 10, y1: 0, x2: 595 - 10, y2: 0, lineWidth: 0.5 }
          ]
        },
        {
          fontSize: 12,
          columns: [
            {
              text: 'Calle 5 Oeste No Diagonal 50 - 03-CALI',
              margin: [20, 5, 20, 0],
              alignment: 'right',
              width: '100%'
            }
          ]
        },
        {
          fontSize: 12,
          columns: [
            {
              text: 'Telf: 316 4071420',
              margin: [20, 0, 20, 0],
              alignment: 'right',
              width: '100%'
            }
          ]
        }
      ],

      content:
      [
        {
          columns:
          [
          {
              table:
              {
                widths: [50, 395, 20, 60 ],
              body:
              [
                [
                  {text: 'DIENTE', bold: true},
                  {text: 'TRATAMIENTO', bold: true},
                  {text: 'FIN', bold: true},
                  {text: 'VALOR', bold: true},
                ],

                  //...quote.toothQuoteDetails.map(sub=>
                  ...quoteWithPrice.map(sub=>
                  (
                    [
                      sub.toothTypeIdString,
                      sub.observations,
                      sub.fixed?'S':'N',
                      sub.price,
                    ]
                  )),

                [
                  {text: '', bold: true},
                  {text: 'TOTAL', bold: true},
                  {text: '', bold: true},
                  {text: this.totalPrice, bold: true},
                ],

              ],
              },
              layout: 'borders'

        },

          ],
          styles: {
            tableHeader: {
              bold: true
            }
          }
        },

      ]
    };
  }

  clearItemForm():void
  {
    this.itemForm.patchValue({
      observations:'',
      treatment:'',
      price:''
    })
  }
//#endregion print
/**
 * Obtiene el nombre de la cara basado en su ID
 */
  getFaceNameById(faceId: number,toothTypeId:number): string
  {
   let temp=[31,32,33,34,35,36,37,38,41,42,43,44,45,46,47,48, 71,72,73,74,75,81,82,83,84,85];
    const toothFaces = [
      { id: 1, name: 'Vestibular'},
      { id: 2, name: 'Mesial'},
      { id: 3, name: 'Distal'},
      { id: 4, name: this.getPalatynoOrLingual(toothTypeId)},
      { id: 5, name: 'Oclusal' },
      { id: 7, name: 'incisal' }

    ];

   // const face = toothFaces.find(x => x.id === faceId);
    const face = this.toothFacesTypeList.find(x => x.id === faceId);

    return face ? face.name : 'Desconocido';
  }

  private getPalatynoOrLingual(toothTypeId: number): string {
   // console.log("En getPalatynoOrLingual toothTypeId es:", toothTypeId);
    let tempFaces=[31,32,33,34,35,36,37,38,41,42,43,44,45,46,47,48, 71,72,73,74,75,81,82,83,84,85];
    return tempFaces.includes(toothTypeId) ? 'Lingual' : 'Palatino';
}

  ngOnDestroy(): void {
        this.busyData$?.unsubscribe();
        this.busy?.unsubscribe();
  }

}
